import React from 'react';

import styled from 'styled-components';

import CompaniesCreateEditModalContentMysteryShoppingShopPriority from './CompaniesCreateEditModalContentMysteryShoppingShopPriority';
import CompaniesCreateEditModalContentMysteryShoppingShopSchedule from './CompaniesCreateEditModalContentMysteryShoppingShopSchedule';
import CompaniesCreateEditModalContentMysteryShoppingTrialShop from './CompaniesCreateEditModalContentMysteryShoppingTrialShop';
import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_STATUS } from '../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 0px 30px 20px;
  border-left: 1px solid var(--line-gray);
`;

const Title = styled.div`
  font-size: 20px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const CompaniesCreateEditModalContentMysteryShopping = () => {
  const { company } = useCompaniesCreateEditModalContext();
  const showTrialScreen = company?.status == COMPANY_STATUS.IN_TRIAL;
  const showPayingCustomerScreen =
    company?.status == COMPANY_STATUS.PAYING_CUSTOMER || company?.status == COMPANY_STATUS.INACTIVE;
  return (
    <Container>
      <Title>Mystery Shopping</Title>
      {showTrialScreen && <CompaniesCreateEditModalContentMysteryShoppingTrialShop />}

      {showPayingCustomerScreen && <CompaniesCreateEditModalContentMysteryShoppingShopSchedule />}
      <CompaniesCreateEditModalContentMysteryShoppingShopPriority />
    </Container>
  );
};

export default CompaniesCreateEditModalContentMysteryShopping;
